export default "__VITE_ASSET__DHQ_XlFr__"